export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: '#F2F5FF',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '44px 0 12px 0',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginTop: '80px',
    fontSize: '24px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#23252F',
    textAlign: 'center',
  },
  description: {
    marginTop: '14px',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'Inter',
    color: '#23252F',
    textAlign: 'center',
  },
  buttonWrapper: {
    justifyContent: 'center',
    gap: '15px',
    marginTop: '14px',
  },
};
